import i18n from '@/i18n'

export default {
  path: '/community',
  name: 'Community',
  meta: {
    title: i18n.t('mainMenu.community'),
    requiresAuth: true,
    role: ['granja-admin']
  },
  component: () => import('@/views/Community.vue'),
  children: [
    {
      path: '',
      alias: 'projects',
      name: 'CommunityProjects',
      meta: {
        title: i18n.t('community.tab.projects'),
        requiresAuth: true,
        role: ['granja-admin']
      },
      component: () => import('@/views/community/Projects.vue')
    },
    {
      path: 'reservations',
      name: 'CommunityReservations',
      meta: {
        title: i18n.t('community.tab.reservations'),
        requiresAuth: true,
        role: ['granja-admin']
      },
      component: () => import('@/views/community/CommunityReservations.vue')
    }
  ]
}
